import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { TextField, Button } from '@mui/material';
import { git_date, git_version, } from '../../gitInfo'
import {makeStyles} from '@material-ui/core/styles';


// import InputMask from "react-input-mask";
import { useForm } from "react-hook-form";
import { validateRut } from "@fdograph/rut-utilities";
import Recaptcha from "../commons/Recaptcha/Recaptcha";
import { validate, cleanRut, format } from "../commons/utils";
import { urlclave, validacedula } from "../../service/service.supersalud";
import { baseUrl, isDev } from "../../config/config";
import { ErrorMessage } from "@hookform/error-message";



import Modal from 'react-bootstrap/Modal'
import claveunica from "../../images/claveunica.svg"

import "./login.css"
import 'bootstrap/dist/css/bootstrap.min.css';




/* const s = new Date(git_date).toLocaleDateString("es-CL")*/

const s = '09-02'
const useStyles = makeStyles((theme) => ({
  errors: {
    color: "red",
    fontHeight: "bold",
  }

}));

const methodDoesNotExist = () => {
  let ola = 1/0

  ola.map((item,index)=>{

  })

}

const LoginMatPage = props => {
  const { user, userLogOut, userLoggedIn } = props;
  const classes = useStyles();


  const history = useHistory();

  const { errors, setError } = useForm();
  const [values, setValues] = useState({
    rut: "",

  });
  const [/*validCaptcha,*/ setValidCaptcha] = useState({});
  let location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const recaptchaRef = React.useRef();



  function onChangeRecaptcha(value) {
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      value === "undefined"
    ) {
      setValidCaptcha(false);
    } else {
      setValidCaptcha(true);
    }
  }
  const onSubmit = async () => {
    try {
      setLoading(true);
      // const token = await recaptchaRef.current.executeAsync();      
      const token = true;
      setError("rut", {
        type: "manual",
        message: ""
      });
      setError("num_serie", {
        type: "manual",
        message: ""
      });
      if (!token) {
        setError("invalid captcha");
        return;
      }
      if (values && (!values.rut || values.rut < 9)) {
        setLoading(false);
        setError("rut", {
          type: "manual",
          message: "Rut es requerido"
        });
        return;
      }
      if (values && (!values.num_serie || values.num_serie < 9)) {
        setLoading(false);
        setError("num_serie", {
          type: "manual",
          message: "Número de serie es requerido"
        });
        return;
      }
      if (validateRut(values.rut) === true) {
        const raw = JSON.stringify({ "rut": values.rut, "num_serie": values.num_serie });
        const resp = await validacedula(raw);
        setLoading(false);
        if (resp.ok) {
          const data = await resp.json();
          console.info("data ", data["user"]["auth"])
          console.info("data ", typeof(data["user"]["auth"]))
          // if (!data["user"] && data["user"]["access"] === undefined){
            console.info(data["user"]["auth"] ===false)
          if ((data["user"]["access"] === undefined) || (data["user"]["auth"] ===false)){
            setError("num_serie", {
              type: "manual",
              message: "Disculpe su RUT no posee tráḿites."
            });
            return history.push( "/login" );
            // setOpen(true);
          }
          window.gtag("event", "ingreso_nro_serie", {
            event_category: "access",
            event_label: "login"
          });
          userLoggedIn(data["user"]);

        } else {

          setError("num_serie", {
            type: "manual",
            message: resp.error
          });

        }

      } else {
        setLoading(false);
        setError("rut", {
          type: "manual",
          message: "Rut invalido"
        });
      }
    } catch (error) {
      setError("num_serie", {
        type: "manual",
        message: error.message
      });
      setLoading(false);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();

    const resp = await urlclave();
    const resp_status = await resp.status;
    setLoading(false);
    if (resp_status === 200) {
      const data = await resp.json();
      window.location.assign(data.url);
    }
  }
  const ValidateRut = (rut) => {

    if (rut !== null && rut !== "") {
      // console.log(rut.length)
      // console.log(validate(cleanRut(rut)))
      if (validate(cleanRut(rut)) !== true) {

        setError("rut", {
          type: "manual",
          message: "El rut ingresado es inválido."
        });
        return
      } else {
        setError("rut", {
          type: "manual",
          message: ""
        });
        setValues({
          ...values,
          rut: format(rut),
        })
      }
    }
  }
  const [show, setShow] = useState(false);


  useEffect(
    () => {
      // alert(window.navigator.userAgent)

      const redirect = urlParams.get("redirect");
      const claveUnitcaMessage = urlParams.get("claveunicaMessage");
      if (claveUnitcaMessage === "true") {
        setOpen(true)
      }
      if (user && user.nombre) {
        if (!user.rut) {
          return history.push("/login");
        }
        if (claveUnitcaMessage === "true") {
          window.gtag("event", "ingreso_clave_unica", {
            event_category: "access",
            event_label: "login"
          });
        }
        return history.push(!redirect ? "/listreclamo" : redirect);
      }
      if (user && !user.auth) {
        userLogOut();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, history, userLogOut]
  );
  return (
    <>
      <div className="contenedor">
        <div className="contenedor-login shadow">
          <div className="titulo-login">
            <h1 className="py-2">Ingresa al Seguimiento de Trámites</h1>
          </div>

          <form className="form-login">

            <TextField
              id="rut"
              onBlur={() => ValidateRut(values.rut)}
              onFocus={() => setError("rut", { type: "manual", message: "" })}
              onChange={({ target: { value } }) => value.length < 14 && setValues({ ...values, rut: format(value) })}
              value={values.rut !== "" ? format(values.rut) : ""}
              name="rut"
              className="my-2 elementos-login-ss mx-auto"
              // error={Error.apellido_p}

              label="Ingrese su RUT"
              variant="outlined"
              size="small"
              autoComplete="off"
              margin="dense"
              required


            />
            <ErrorMessage
              className={`${classes.errors}`}
              name="rut"
              as="div"
              errors={errors}
            />


            <TextField

              id="num_serie"
              onChange={({ target: { value } }) => {
                setValues({ ...values, num_serie: value });
              }}

              onBlur={({ target: { value } }) => {

                if (value.length > 10) {
                  setError("num_serie", {
                    type: "manual",
                    message: "Numero de Serie muy Largo"
                  });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSubmit()
                }
              }}
              inputProps={{ maxLength: 10 }}
              name="num_serie"
              className="my-2 elementos-login-ss mx-auto"
              // error={Error.apellido_p}
              fullWidth
              label="Ingrese N° de Serie"
              variant="outlined"
              size="small"
              autoComplete="off"
              margin="dense"
              required
            />
            <ErrorMessage
              className={`${classes.errors}`}
              name="num_serie"
              as="div"
              errors={errors}
            />
            <p className="text-center my-2" onClick={() => setShow(!show)} style={{ fontSize: 12, cursor: "pointer" }}>¿Dónde se encuentra el número de documento?</p>

            <Button
              color="primary"
              className="btn-login-ss elementos-login-ss mx-auto text-center my-2"
              disabled={loading ? true : false}
              onClick={onSubmit}
            >
              INGRESAR{" "}
              {loading ? (

                <div
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : null}
            </Button>


            <p className="text-center my-2" style={{ fontSize: 12 }}>Puedes acceder con tu clave única</p>

            <Button
              color="primary"
              className="btn-login-ss elementos-login-ss mx-auto my-2"
              onClick={handleClick}
              disabled={loading ? true : false}
            >
              <img
                src={claveunica}
                alt="Imagen clave unica Superintendencia De Salud"
              />{" "}
          CLAVE ÚNICA
          {loading ? (
                <div
                  className="spinner-border spinner-border-sm ml-2"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : null}
            </Button>

            <div className="mx-auto my-2">
              <a
                href="https://claveunica.gob.cl/"
                className="mx-auto"
                style={{ color: "#0064ac" }}
              >
                ¿No tienes clave única?
        </a>
            </div>

          </form>

          {isDev ? (
            null
/*             <>
              <p>{git_version}</p>
              <p>{s}</p>
            </> */
          ) : null}

        </div>
         {/* <button onClick={()=>{methodDoesNotExist()}}>Break the world</button> */}
      </div>


      <Recaptcha {...{ onChangeRecaptcha, recaptchaRef }} />{" "}

      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Aquí puede encontrar su número de serie.
        </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <img
            src="https://servicios.superdesalud.gob.cl/ReclamosApbWeb/img/index/ci-nueva.png"
            className="img-fluid mx-auto d-block"
            alt="Imagen Rut Superintendencia De Salud"
          />

          <img
            src="https://servicios.superdesalud.gob.cl/ReclamosApbWeb/img/index/ci-antiguo.png"
            className="img-fluid mx-auto my-2 d-block"
            alt="Imagen Rut Superintendencia De Salud"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
export default LoginMatPage;
